import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ErrorBox } from "./components/common";
import ProjectList from "./components/ProjectList";
import ClientSearch from "./components/ClientSearch";
import { errorMessage, staffDmApi } from "./dmApi";
import "./dm.css";

/**
 * Digital Marketing landing page. Staff search / list DM-enrolled clients and open a client's
 * details page; portal users (api=portalDmApi) go straight to their own company's projects.
 */
function DMProjects({ api = staffDmApi, basePath = "/dm-projects" }) {
  const navigate = useNavigate();
  const [meta, setMeta] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (api.isStaff) return;
    api.meta().then(setMeta).catch((err) => setError(errorMessage(err, "Could not load options")));
  }, [api]);

  return (
    <div className="dmp">
      {api.isStaff ? (
        <>
          <div className="dmp-header">
            <div>
              <h2 className="dmp-title">Clients</h2>
            </div>
          </div>
          <div className="dmp-card dmp-card--clients">
            <ClientSearch api={api} onSelect={(t) => navigate(`${basePath}/client/${t.tenant_id}`)} />
          </div>
        </>
      ) : (
        <>
          <div className="cportal-page-head">
            <h1>Digital Marketing</h1>
          </div>
          <ErrorBox message={error} />
          <ProjectList api={api} meta={meta} basePath={basePath} title="Projects" />
        </>
      )}
    </div>
  );
}

export default DMProjects;
